import format from 'date-fns/format'

export default {
  install(Vue) {
    Vue.prototype.$parseDate = function(date) {
      const formatStr = 'MMMM dd, yyyy';
      return format(new Date(date), formatStr);
    }

    Vue.prototype.$parseDateTime = function(date) {
      const formatStr = 'MMM do, yyyy HH:mm aaaa';
      return format(new Date(date), formatStr);
    }

    // Providing both for injection:
    Vue.mixin({
      provide() {
        return {
          $parseDate: this.$parseDate,
          $parseDateTime: this.$parseDateTime
        }
      },
    });
  },
}